var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MailPageSingle page"},[_c('div',{staticClass:"mb-5"},[_c('Mail',{attrs:{"id":parseInt(_vm.id)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }